
import { DossierConfigService } from "@/services/dossier-config-service";
import { IChartDataPerMonthPerYear, ChartDataPerMonth } from "@/utils/chart-income";
import {AppApexChart} from "@/utils/apex-charts";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			printModal: false
		};
	},
	props: {
		showPrevYear: Boolean,
		chartData: Object as () => IChartDataPerMonthPerYear,
		maxToShowYears: Number,
		chartType: {
			type: String,
			default: "bar",
		},
	},
	computed: {
		maxToShowYearsComputed():number {
			if (!this.showPrevYear) {
				return 1;
			}
			if (!this.maxToShowYears) {
				return 2;
			}
			return this.maxToShowYears;
		},
		startMonth():number {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth;
		},
		years():ChartDataPerMonth[]{
			return this.chartData.Years;
		},
		displayData():any[] {
			if (this.years.length == 0) {
				let emptyIncome = [];
				for (let i = 0; i < 12; i++) {
					emptyIncome.push(0);
				}
				[{
					name: "loading",
					data: emptyIncome
				}];
			}
			return [...this.years].splice(0, this.maxToShowYearsComputed).map(y=>{
				return {
					name: y.year,
					data: y.getOrderedData(this.startMonth)
				};
			});
		},
		chartOptions():any {
			return this.getChartOptions();
		},
		printChartOptions():any {
			let options = this.getChartOptions();
			options.chart.animations = {enabled: false};
			return options;
		}
	},
	methods: {
		// eslint-disable-next-line max-lines-per-function
		getChartOptions():any{
			let months = [] as string[];
			for (let i = 0; i < 12; i++) {
				let monthNumber = i + 1 + this.startMonth;
				if (monthNumber > 12) {
					monthNumber -= 12;
				}
				months.push(this.$ct("common.months." + monthNumber).toString().substring(0, 3));
			}

			var dataLabelOptions = {};
			if (this.chartType == "bar") {
				dataLabelOptions = {
					enabled: true,
					formatter(val:any) {
						return val ? val : "";
					},
					offsetY: -20,
					style: {
						fontSize: "12px",
						colors: ["#304758"]
					}
				};
			}

			return {
				chart: {
					toolbar: {
						show: false
					},
				},
				grid: {},
				yaxis: {},
				stroke: {},
				plotOptions: {
					bar: {
						dataLabels: {
							position: "top"
						}
					}
				},
				dataLabels: dataLabelOptions,
				xaxis: {

					categories: months,
					crosshairs: {show: false},
					axisBorder: {
						show: false
					},
					axisTicks: {color: "#ededed"},
					labels: {
						style: {
							fontFamily: "Arial",
							fontSize: "14px",
							"-webkit-font-smoothing": "antialiased"
						}
					}
				},
			};
		},
		print(){
			this.printModal = true;
			setTimeout(()=>{
				if (!this.$refs.printChart) return;
				let w = window.open("", "PRINT", "widht=600px,height=400px");
				if (!w) return;
				console.log((this.$refs.printChart as HTMLDivElement).outerHTML);
				w.document.write(`<html><head></head><body>`);
				w.document.write((this.$refs.printChart as HTMLDivElement).innerHTML);
				w.document.write("</body></html>");
				w.focus();
				w.print();
				w.close();
			}, 1000);
			setTimeout(()=>{
				this.printModal = false;
			}, 2000);
		}
	},
	components: {
		AppApexChart
	},
	i18nEx: {
		componentPrefix: "components.charts-IncomeChart"
	}
});
